import React from 'react';
import PropTypes from 'prop-types';

const DownloadOverlayCloseButton = (props) => {
  const styles = {
    border: 'none',
    display: 'block',
    width: 50,
    height: 50,
  };

  return (
    <button onClick={props.onClick} id="staticOverlayCloseButton" className={'download-overlay-close-button'} style={styles} />
  );
};

DownloadOverlayCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default DownloadOverlayCloseButton;




// WEBPACK FOOTER //
// ./src-react/download-overlay/components/DownloadOverlayCloseButton.jsx